import { Box, Typography } from '@mui/material';

type StatusType = 'FAILED' | 'SUCCESS' | 'IN_PROGRESS';

const STATUS_CONFIG: Record<
  StatusType,
  {
    label: string;
    color: string;
    bg: string;
    border: string;
  }
> = {
  FAILED: {
    label: 'Failed',
    color: '#D92D20',
    bg: '#FFF5F5',
    border: '#F04438',
  },
  SUCCESS: {
    label: 'Completed',
    color: '#027A48',
    bg: '#ECFDF3',
    border: '#12B76A',
  },
  IN_PROGRESS: {
    label: 'In Progress',
    color: '#B54708',
    bg: '#FFFAEB',
    border: '#F79009',
  },
};

type ImportUsersDrawerProps = {
  status: string;
};

export default function StatusPill({
  status,
}: ImportUsersDrawerProps) {
  if (!status) return '--';

  const key = status
    .toUpperCase()
    .replace(' ', '_') as StatusType;
  const config = STATUS_CONFIG[key];

  if (!config) return status;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        px: '10px',
        py: '4px',
        borderRadius: '999px',
        border: `1px solid ${config.border}`,
        backgroundColor: config.bg,
        width: 'fit-content',
      }}>
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: config.border,
        }}
      />
      <Typography
        fontSize={13}
        fontWeight={500}
        color={config.color}>
        {config.label}
      </Typography>
    </Box>
  );
}
